module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAZCAYAAAAiwE4nAAAACXBIWXMAAAsSAAALEgHS3X78AAABR0lEQVRIie2W4VHCQBCFv3UsICVQQqgA6EArECsBK7AEoIJoBWgHdCBUYDp4zsJmxMRkCHP8y5u5yeXlLm/f3e0mRg9IegXyHlM2ZrY+J+4bQ7pRiX12jjrhCRjVyb6CRzEzWzbYGiRNGiRw12BujEFwEOyNP2khafVf7pwhvzAHW1HPwzngleHQMqErmKsEiXL00WA7krkPhlN6FSQ9xH5Pon8bQUm5pC+gAEog875z/oyWQ3O1GLAFdsCs9tgD2Eoap3ToH+e9mc3MbA94Ts+jPwvHi2QOgSnw2GABMyslvXhQSRxKmka3jP1SBLDQCb7U7jRL5XAX1yxcZrHEzm9CbFpFVygdijPXfkiWtfvCJI1S1Mh4hx+UtZk9V2kQ7tyt1+lxAp1fSJrHWvk+rqJ9R3NBev2XXijqTv3lVaF/B96O6QH8ANlc6IK0j3E9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/add-business.png
// module id = 1263
// module chunks = 0